import { render, staticRenderFns } from "./SendDetailExpr.vue?vue&type=template&id=2ab8cd27&scoped=true&"
import script from "./SendDetailExpr.vue?vue&type=script&lang=js&"
export * from "./SendDetailExpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8cd27",
  null
  
)

export default component.exports